import { useIsMobile } from "@/hooks/use-is-mobile";
import { useOnlineStatus } from "@/hooks/use-online-status";
import { AccountMenu } from "./AccountMenu";
import { BottomTabBar } from "./BottomTabBar";
import { Sidebar } from "./Sidebar";
import { ThemeToggle } from "./ThemeToggle";

export function DashboardLayout({ children }: { children: React.ReactNode }) {
  const isMobile = useIsMobile();
  const isOnline = useOnlineStatus();

  return (
    <div className="flex h-screen overflow-hidden">
      {!isMobile && <Sidebar />}

      <div className="flex flex-1 flex-col overflow-hidden">
        {!isOnline && (
          <div className="bg-amber-500/10 px-4 py-1.5 text-center text-xs font-medium text-amber-600 dark:text-amber-400">
            You're offline — some data may be out of date.
          </div>
        )}

        {/* Header */}
        <header className="flex h-16 items-center justify-between border-b border-border bg-background px-4 md:px-6">
          <div className="flex items-center gap-3">
            {isMobile && <span className="font-display text-lg font-bold truncate">Offtime</span>}
          </div>
          <div className="flex items-center gap-3">
            <ThemeToggle />
            <AccountMenu />
          </div>
        </header>

        {/* Scrollable content */}
        <main className={`flex-1 overflow-y-auto p-4 md:p-6 ${isMobile ? "pb-20" : ""}`}>
          <div className="mx-auto max-w-5xl">{children}</div>
        </main>
      </div>

      {isMobile && <BottomTabBar />}
    </div>
  );
}
